import { useTranslation } from "react-i18next";
import type { SeatableReservation } from "../../../../../api/reservations";
import { formatClock } from "../../../../reservations/logic/dayTime";
import type { SeatHourGroup } from "./seatReservationGroups";
import { SeatReservationRow } from "./SeatReservationRow";

/**
 * Списъкът на „Настани" — една колона по часове със залепен разделител
 * „18:00 ————". Кликът/↑↓ само избират — настаняването е от бутона долу (Enter).
 */
export const SeatReservationList = ({
  groups,
  selectedId,
  nowMs,
  isNarrow,
  onSelect,
}: {
  groups: SeatHourGroup[];
  selectedId: number | null;
  nowMs: number;
  isNarrow: boolean;
  onSelect: (reservation: SeatableReservation) => void;
}) => {
  const { t } = useTranslation();
  if (groups.length === 0) {
    return <p className="m-0 py-10 text-center text-[13px] text-pos-muted">{t("seatReservation.noResults")}</p>;
  }

  return (
    <div className="flex flex-col">
      {groups.map((group) => (
        <section key={group.hourMs}>
          {/* Лепнещ разделител — при дълъг час се вижда кой е. */}
          <div className="sticky top-0 z-[1] flex items-center gap-2 bg-pos-card py-1.5">
            <span className="font-pos-mono text-[12px] font-bold text-pos-ink2">{formatClock(group.hourMs)}</span>
            <span className="h-px flex-1 bg-pos-line2" />
          </div>
          <div className="flex flex-col gap-1.5 pb-1.5">
            {group.reservations.map((reservation) => (
              <SeatReservationRow
                key={reservation.id}
                reservation={reservation}
                nowMs={nowMs}
                selected={reservation.id === selectedId}
                isNarrow={isNarrow}
                onClick={() => onSelect(reservation)}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};
